/**
 * @file
 * Add class when scroll to element.
 *
 * Add to paragraph or other element. When you scroll down to this
 * element the trigger class will appear on it.
 *
 * @example Add class: .cpl-scroll-trigger
 * You'll get class .scrolled when you'll scroll down to this element.
 */

const $scroll = $('.cpl-scroll-trigger', context);

$scroll.once('scroll-trigger').each((index, el) => {
  const $this = $(el);

  let scrollTimeout;
  $(window).scroll(() => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      if (
        $(window).scrollTop() > $this.offset().top - 200 &&
        !$this.hasClass('scrolled')
      ) {
        $this.addClass('scrolled');
      }
    }, 100);
  });
});
